import React, { useContext, useEffect, useState } from 'react';

import useAccountRouter from 'Components/Account/useAccountRouter';
import { VehicleContext } from 'Context/VehicleContext';

import AccountPermitsChecker from './AccountPermitsChecker';

export const useAccountPermitsChecker = () => {
	const vehicle = useContext(VehicleContext);
	const { category, slug } = useAccountRouter();
	const [accountPermits, setAccountPermits] = useState(
		new AccountPermitsChecker({
			context: {
				category,
				slug,
			},
			vehicle,
		}),
	);

	useEffect(() => {
		setAccountPermits(
			new AccountPermitsChecker({
				context: {
					category,
					slug,
				},
				vehicle,
			}),
		);
	}, [vehicle, category, slug]);

	return accountPermits;
};

/**
 * Adds `permits` prop to component
 *
 * @returns {React.Component} AccountHistoryPermitsCheckerHOC
 */
export const WithAccountPermitsChecker = () => (Component) => {
	const AccountPermitsCheckerHOC = (params) => {
		const permits = useAccountPermitsChecker();

		return <Component {...params} permits={permits} />;
	};

	return AccountPermitsCheckerHOC;
};
